import React, { Component } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import ServerSideDataSource from './ServerSideDataSource';
import { updateSpendControllerBaseline } from 'utils/apiRequests';
import { isEqual, isUndefined } from 'lodash';

class TableView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			gridApi: null,
		};
		this.gridRef = React.createRef();
	}

	gridOptions = () => {
		const { data } = this.props;

		return {
			modules: AllModules,
			columnDefs: data.columnDefs,
			cacheBlockSize: 200,
			maxBlocksInCache: 6,
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
			rowHeight: 35,
			rowModelType: 'serverSide',
			maxConcurrentDatasourceRequests: 1,
			multiSortKey: 'ctrl',
			enableRangeSelection: true,
			suppressCutToClipboard: true,
		};
	};

	defaultColDefs = {
		flex: 1,
		minWidth: 100,
		resizable: true,
		editable: false,
	};

	componentDidMount() {
		const { data, filters, selectedSpendType } = this.props;
		const tempDataModel = {
			tail_Spend_Type: {
				values: selectedSpendType,
				filterType: 'set',
				filter: 'agSetColumnFilter',
			},
		};
		const gridOptionsnew = {
			data,
			suppressRowClickSelection: true,
			...this.gridOptions(),
			filters: Object.assign({}, filters, ...data.filterModel, tempDataModel),
		};

		const datasource = ServerSideDataSource(
			gridOptionsnew,
			this.gridRef.current.columnApi,
			this.gridRef.current.api
		);
		this.gridRef.current.api.setServerSideDatasource(datasource);
	}

	componentDidUpdate(prevProps) {
		const {
			filters,
			uploadRefresh,
			selectedSpendType,
			workshopState,
		} = this.props;
		if (
			!isEqual(filters, prevProps.filters) ||
			!isEqual(uploadRefresh, prevProps.uploadRefresh) ||
			!isEqual(selectedSpendType, prevProps.selectedSpendType) ||
			!isEqual(workshopState, prevProps.workshopState)
		) {
			const { data, selectedSpendType } = this.props;
			const tempDataModel = {
				tail_Spend_Type: {
					values: selectedSpendType,
					filterType: 'set',
					filter: 'agSetColumnFilter',
				},
			};
			const gridOptionsnew = {
				data,
				suppressRowClickSelection: true,
				...this.gridOptions(),
				filters: Object.assign({}, filters, ...data.filterModel, tempDataModel),
			};
			const datasource = ServerSideDataSource(
				gridOptionsnew,
				this.gridRef.current.columnApi,
				this.gridRef.current.api
			);
			this.gridRef.current.api.setServerSideDatasource(datasource);
		}
	}

	onGridReady = params => {
		this.setState({ gridApi: params.api });
		const { data, filters, selectedSpendType } = this.props;
		const tempDataModel = {
			tail_Spend_Type: {
				values: selectedSpendType,
				filterType: 'set',
				filter: 'agSetColumnFilter',
			},
		};
		const gridOptionsnew = {
			data,
			suppressRowClickSelection: true,
			...this.gridOptions(),
			filters: Object.assign({}, filters, ...data.filterModel, tempDataModel),
		};
		const datasource = ServerSideDataSource(
			gridOptionsnew,
			params.columnApi,
			params.api
		);
		params.api.setServerSideDatasource(datasource);
	};

	handleCellValueChange = async event => {
		const { gridApi } = this.state;
		const selectedRowNodes = gridApi.getSelectedNodes();

		if (
			event.oldValue &&
			event.newValue &&
			event.oldValue.toString() === event.newValue.toString() &&
			selectedRowNodes.length === 1
		) {
			return;
		}

		const modifiedRows = [];
		modifiedRows.push(event.data);
		if (isUndefined(event.data.concatenatedIds)) {
			delete event.data.total_Savings;
			await updateSpendControllerBaseline([
				{ ...event.data, spend: null, total_Savings: null },
			]);
		} else {
			delete event.data.iD;
			const resultArray = event.data.concatenatedIds
				.split(',')
				.map(item => ({ id: Number(item.trim()) }));
			const tempArray = resultArray.map(data => ({
				id: data.id,
				...event.data,
				spend: null,
				total_Savings: null,
			}));
			await updateSpendControllerBaseline(tempArray);
		}
	};

	render() {
		const { data } = this.props;

		return (
			<>
				<div style={{ height: '400px' }} className="ag-theme-balham">
					<AgGridReact
						{...this.gridOptions()}
						ref={this.gridRef}
						modules={AllModules}
						columnDefs={data.columnDefs}
						cacheBlockSize={200}
						defaultColDef={this.defaultColDefs}
						maxBlocksInCache={6}
						onCellValueChanged={this.handleCellValueChange}
						enableGroupEdit={true}
						rowModelType="serverSide"
						maxConcurrentDatasourceRequests={1}
						multiSortKey="ctrl"
						onGridReady={this.onGridReady}
						enableRangeSelection={true}
						suppressCutToClipboard={true}
						suppressCellFocus={true}
					/>
				</div>
			</>
		);
	}
}

export default TableView;
